import toastr from 'toastr';
import Service from '../../../utility/Service';

export const UPDATE_PROMOCODE_GET_SUCCESS = "UPDATE_PROMOCODE_GET_SUCCESS";
export const UPDATE_PROMOCODE_GET_FAILURE = "UPDATE_PROMOCODE_GET_FAILURE";
export const UPDATE_PROMOCODE_GET_REQUEST = "UPDATE_PROMOCODE_GET_REQUEST";
export const UPDATE_PROMOCODE_GET_RESET = "UPDATE_PROMOCODE_GET_RESET";


export const promoCodeUpdateFailure = () => ({
    type: UPDATE_PROMOCODE_GET_FAILURE,
    loading: true,
    update: false,
    promoCodeUpdatedData: []
});

export const promoCodeUpdateSuccess = (data, pageNo, pageSize) => ({
    type: UPDATE_PROMOCODE_GET_SUCCESS,
    loading: false,
    update: true,
    promoCodeUpdatedData: data
});

export const promoCodeUpdateRequest = () => ({
    type: UPDATE_PROMOCODE_GET_REQUEST,
    loading: true,
    update: false,
    promoCodeUpdatedData: []
});

export const promoCodeUpdateReset = () => ({
    type: UPDATE_PROMOCODE_GET_RESET,
    loading: false,
    update: false,
    promoCodeUpdatedData: []
});

export const updatePromoCode = (id, values, pageNo, pageSize) => (dispatch, getState) => {
    toastr.remove()
    dispatch(promoCodeUpdateRequest())
    let url = "promo_code/" + id
    Service.patch(url, values,
        (response) => {
            if (response && response.status && response.status === 200) {
                let data = {
                    data: response.data,
                    pagination: response.pagination
                }
                dispatch(promoCodeUpdateSuccess(data));
                dispatch(promoCodeUpdateReset());

            } else {
                dispatch(promoCodeUpdateFailure());
                toastr.error('Something Went Wrong');
            }
        }
    )
};